import ServiceProviderContainer from "./ServiceProvider.container";

export default ServiceProviderContainer;
